<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="false"
  class="health-summary"
>
  <div class="wrapper--spacing-all">
    <div class="flex--responsive-gt-sm flex--gutter flex--align-center">
      <div class="spacing--margin-horizontal spacing--margin-half-bottom">
        <app-production-picker
          (productionChanged)="onProductionChanged($event)"
        ></app-production-picker>
      </div>
    </div>

    <h5 class="text--h5">{{ 'health.health-summary.header' | translate }}</h5>
    @if (tableConfig) {
      <agr-table data-test="health-summary__table" [config]="tableConfig"> </agr-table>
    }
    <app-year-summary [selectedDate]="selectedDate"></app-year-summary>
  </div>
</agr-page-toolbar>
